export const sp = {
    homelabel: 'HOGAR',
    categoriesLabel:'SCategories',
    aboutustext: 'SOBRE NOSOTROS',
    myOrdersLabel: 'ORDENES',
    myProfileLabel: 'PERFIL',
    englishLabel: 'Inglés',
    spanishLabel: 'Español',
    loginLabel: 'Iniciar Sesión',
    logoutLabel: 'CERRAR SESIÓN',
    contactUs: 'Contacta con nosotros',
    languageLabel: 'IDIOMA',
    accountText: 'Cuenta',
    myItemsLabel: 'ELEMENTOS',
    uploadedSuccessfullyLabel: 'Uploaded successfully',
    failedToUploadLabel: 'Failed to upload!',
    mandatoryFieldsLabel: 'Images, title, category, subcategory, price, stock, deliveryfee are mandatory',
    updatedSuccessfullyLabel: 'Updated successfully',
    failedToUpdateLabel: 'Failed to update!',
    closeLabel: 'Close',
    selectImagesLabel: 'Select Images',
    productTitleLabel: 'Product title',
    categoryLabel: 'Category',
    selectCategoryLabel: 'Select Category',
    subcategoryLabel: 'Subcategory',
    selectSubcategoryLabel: 'Select Subcategory',
    descriptionLabel: 'Description',
    productDescriptionLabel: 'Product description',
    pricingStockLabel: 'Pricing & Stock',
    priceLabel: 'Price',
    stockLabel: 'Stock',
    discountLabel: 'Discount',
    deliveryLabel: 'Delivery',
    deliveryChargesLabel: 'Delivery Charges',
    updateProductLabel: 'Update Product',
    uploadProductLabel: 'Upload Product',
    addNewItemLabel: 'Add new item',
    orderPickRequestLabel: 'Order Pick Request',
    youHaveOItemsLabel: 'You have 0 items.',
    insightLabel: 'PERSPICACIA',
    myEarningsLabel: 'GANANCIAS',
    deletProductLabel: 'Delete Item',
    distanceLabel: 'Distance',
    requestToPickOrderLabel: 'Request to pick order',
    orderStatusLabel: 'Order Status',
    paymentLabel: 'Payment',
    recentTransactionsLabel: 'Recent Transactions',
    revenueLabel: 'Revenue',
    earningsLabel: 'Earnings',
    orderStatisticsLabel: 'Order Statistics',
    totSellingProductsLabel: 'Top Selling Products',
    ordersLabel: 'Orders',
    pendingLabel: 'Pending',
    noOfSoldsLabel: 'No. of Solds',
    requestSentSuccessLabel: 'Request sent successfully',
    failedToSendRequestLabel: 'Failed to send request!',
    orderIdLabel: 'Order ID',
    orderedOnLabel: 'Ordered On',
    requestSentToLabel: 'Request sent to',
    makeRequestToOtherLabel: 'Make request to other'
}